var map = {
	"./bottom-row/sync.js": 6474,
	"./copyright/sync.js": 8480,
	"./menu/sync.js": 2730,
	"./middle-row/sync.js": 1205,
	"./socials/sync.js": 7131,
	"./sync.js": 16,
	"./top-row/sync.js": 1197,
	"./widget-area-1/sync.js": 1941,
	"./widget-area-2/sync.js": 3950,
	"./widget-area-3/sync.js": 3975,
	"./widget-area-4/sync.js": 1664,
	"./widget-area-5/sync.js": 9335,
	"./widget-area-6/sync.js": 2558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5297;